module.exports = {
    zh: {
        addCompanyDynamics: '新增公司动态',
        companyDynamics: '公司动态',
        addGardenDynamics: '新增园所动态',
        gardenDynamics: '园所动态',
        number: '序号',
        photo: '图片',
        uploadPhoto: '上传图片',
        title: '标题',
        time: '时间',
        provenance: '出处',
        sorting: '排序',
        operation: '操作',
        abstract: '摘要',
        address: '地址URL',
        release: '发布',
        check: '查看',
        determine: '确定',
        cancel: '取消',
        modifySort: '修改排序',
    },
    en: {
        addCompanyDynamics: 'New company dynamics',
        companyDynamics: 'Company dynamics',
        addGardenDynamics: 'New garden dynamics',
        gardenDynamics: 'Garden dynamics',
        number: 'number',
        photo: 'photo',
        uploadPhoto: 'To upload pictures',
        title: 'title',
        time: 'time',
        provenance: 'provenance',
        sorting: 'The sorting',
        operation: 'operation',
        abstract: 'Abstract',
        address: 'address URL',
        release: 'release',
        check: 'To view',
        determine: 'determine',
        cancel: 'cancel',
        modifySort: 'Modify the sort',

    }  
  }
  



// WEBPACK FOOTER //
// ./src/components/i18n/lang/websiteNewsUpdate.js